import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

const config = {
  apiKey: "AIzaSyCbjicha1zyennVejmOE-Eve80m8wff1T0",
  authDomain: "collie-vn.firebaseapp.com",
  databaseURL: "https://collie-vn.firebaseio.com",
  projectId: "collie-vn",
  storageBucket: "collie-vn.appspot.com",
  messagingSenderId: "662033781520",
  appId: "1:662033781520:web:6cc351641b49b056dc0b95",
  measurementId: "G-8CP8FHTYTJ",
};

export const createUserProfileDocument = async (userAuth, additionalData) => {
  if (!userAuth) return;
  const userRef = firestore.doc(`users/${userAuth.uid}`);
  const snapShot = await userRef.get();
  if (!snapShot.exists) {
    const { displayName, email } = userAuth;
    const createAt = new Date();
    try {
      await userRef.set({
        displayName,
        email,
        createAt,
        ...additionalData,
      });
    } catch (error) {
      console.log("error creating user", error.message);
    }
  }
  return userRef;
};

export const createNewPet = async (data) => {
  const petRef = firestore.doc(`pets/${data.microchip}`);
  const snapShot = await petRef.get();
  console.log(data);
  if (!snapShot.exists) {
    try {
      await petRef.set({
        ...data,
      });
    } catch (error) {
      console.log("error creating pet", error.message);
    }
  } else {
    try {
      await petRef.update({
        ...data,
      });
    } catch (error) {
      console.log("error updating pet", error.message);
    }
  }

  return petRef;
};

export const getPetInfo = async (microchip) => {
  const petRef = firestore.doc(`pets/${microchip}`);
  let value;
  await petRef
    .get()
    .then((doc) => {
      if (!doc.exists) {
        console.log("No such document!");
      } else {
        value = doc.data();
      }
    })
    .catch((err) => {
      console.log("Error getting document", err);
    });
  return value;
};

firebase.initializeApp(config);

export const auth = firebase.auth();
export const firestore = firebase.firestore();

const provider = new firebase.auth.GoogleAuthProvider();
provider.setCustomParameters({ prompt: "select_account" });
export const signInWithGoogle = () => auth.signInWithPopup(provider);

export default firebase;
